import { Box } from '@chakra-ui/react';

export interface MessageMediaProps {
  isMe: boolean;
  children: React.ReactNode;
}

export function MessageMedia({ isMe, children }: MessageMediaProps) {
  return (
    <Box
      width="268px"
      px="3"
      py="2.5"
      borderRadius="md"
      bg={isMe ? '#ede7f6' : '#FFF'}
      backdropFilter="blur(2px)"
    >
      <Box px="3" py="2.5" borderRadius="md" bg="rgba(0, 0, 0, 0.03)">
        {children}
      </Box>
    </Box>
  );
}
